'use client';

import { Image, ImageCircleItem, Padding, Typography } from '@musinsa/mds';
import { useQuery } from '@tanstack/react-query';
import { twMerge } from 'tailwind-merge';
import { TrackingDataProvider } from '../../common/components/TrackingDataProvider';
import { getCdnUrl } from '../../common/utils/getCdnUrl';
import { MyShopSnsLinks } from '../../myShop/components/MyShopSnsLinks';
import { curatorQueries } from '../../query-factory';

interface Props {
  snsTitle: string;
  className?: string;
}

export const ShopProfile = ({ snsTitle, className }: Props) => {
  const { data: profile, isPending: isProfilePending } = useQuery({
    ...curatorQueries.profile.profileBySnsTitle(snsTitle),
  });

  return (
    <Padding className={twMerge('flex flex-col bg-[#f5f5f5]', className)} x="4" top="3" bottom="1">
      <div className="flex items-center gap-[16px]">
        <ImageCircleItem size="56" className="flex-shrink-0">
          <Image
            src={
              isProfilePending || !profile?.profileImage
                ? getCdnUrl('/images/profile/common/default.png')
                : profile?.profileImage
            }
            alt="profile"
          />
        </ImageCircleItem>
        <div className="flex flex-col gap-[2px] flex-1 min-w-0">
          <Typography variant="body13pxMed">{profile?.nickname}</Typography>

          <Typography variant="body13pxReg" wordBreak="breakAll">
            {profile?.shopDescription}
          </Typography>

          {profile?.snsLinks && (
            <TrackingDataProvider
              data={{
                page_name: 'curator_shop',
              }}
            >
              <MyShopSnsLinks snsLinks={profile?.snsLinks} />
            </TrackingDataProvider>
          )}
        </div>
      </div>
    </Padding>
  );
};
